export const DEFAULT_TOKEN_LIST_URL = 'https://60bf2ce297295a0017c41fe9.mockapi.io/nightmare/tokens'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]
